/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: modal
 | -------------------------------------------------------------
 |
 |  Functionality for modals.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const modal = document.querySelector('.modal__modal')
const modalOverlay = document.querySelector('.mgbdes__modal--overlay')
const modalOpen = document.querySelector('[data-open-modal]')
const modalClose = document.querySelector('#close-modal')

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

/**
 * Trap focus
 */
const trapFocus = event => {
  const focusables = modal.querySelectorAll('input, button')
  const firstFocusable = focusables[0]
  const lastFocusable = focusables[focusables.length - 1]

  // direct focus to first focusable
  if (document.activeElement === lastFocusable && event.key === 'Tab' && !event.shiftKey) {
    event.preventDefault()
    firstFocusable.focus()
  }

  // direct focus to last focusable
  if (document.activeElement === firstFocusable && event.key === 'Tab' && event.shiftKey) {
    event.preventDefault()
    lastFocusable.focus()
  }
}

/**
 * Opens Modal
 */
const openModal = _ => {
  document.body.classList.add('modal-is-open')

  // title focus
  // const title = modal.querySelector('.dialogue__title')
  // title.focus()

  // trap focus
  document.addEventListener('keydown', trapFocus)

  // toggle aria expanded
  modalOpen.setAttribute('aria-expanded', true)
}

/**
 * Closes Modal
 */
const closeModal = _ => {
  document.body.classList.remove('modal-is-open')
  modalOpen.focus()

  // remove trap focus
  document.removeEventListener('keydown', trapFocus)

  // toggle aria expanded
  modalOpen.setAttribute('aria-expanded', false)
}

/**
 * Checks if modal is open
 */
const isModalOpen = _ => {
  return document.body.classList.contains('modal-is-open')
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

modalOpen && modalOpen.addEventListener('click', _ => {
  openModal()
})

modalClose && modalClose.addEventListener('click', _ => {
  closeModal()
})

modalOverlay && modalOverlay.addEventListener('click', event => {
  if (!event.target.closest('.modal')) {
    closeModal()
  }
})

document.addEventListener('keydown', event => {
  if (isModalOpen() && event.key === 'Escape') {
    closeModal()
  }
})
